<template>
  <div class="entity-materializer-wrapper">
    <EmbeddedApp
      :token="token"
      :lang="lang"
      :api-base-url="apiBaseUrl"
    />
  </div>
</template>

<script>
// Configuración › Materializaciones (MENU_TYPE_ID «materialize»): embebe el configurador visual
// vue-entity-materializer con el token, el idioma y la URL de servicios de la sesión.
import EmbeddedApp from '@vue-entity-materializer/EmbeddedApp.vue'
import Configuration from '@/configuration'

export default {
  name: 'entity-materializer',
  components: { EmbeddedApp },
  props: ['content', 'type', 'apiDefinitionId', 'id'],
  data () {
    return { _tokenTick: 0 }
  },
  computed: {
    token () {
      // eslint-disable-next-line no-unused-expressions
      this._tokenTick // dependencia reactiva para forzar la relectura del token
      return window.localStorage.getItem('user-token') || ''
    },
    lang () {
      return this.$ml ? this.$ml.current : 'es'
    },
    apiBaseUrl () {
      return Configuration.value('API_SERVICES_URL') || ''
    }
  },
  mounted () {
    this.$emit('definitionLoaded')
    this._tokenTick++
  }
}
</script>

<style scoped>
.entity-materializer-wrapper {
  overflow: auto;
  height: 100%;
  min-height: 600px;
}
</style>
